var _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLoaderVehicle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1200",
    width: "300px",
    height: "330px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10,0)",
    fill: "#bebebe"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M733.1,184.8h-60.9c-13.6,0-24.7,11.1-24.7,24.7v62.3c0,13.6,11.1,24.7,24.7,24.7h60.9 c13.6,0,24.7-11.1,24.7-24.7v-62.3C757.7,195.9,746.7,184.8,733.1,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M329.1,516.6V601c0,9.5,7.7,17.2,17.2,17.2h62.3c9.5,0,17.2-7.7,17.2-17.2V434.4c0-9.5-7.7-17.2-17.2-17.2 H242.1c-9.5,0-17.2,7.7-17.2,17.2v62.3c0,9.5,7.7,17.2,17.2,17.2h84.4C328,513.9,329.1,515.1,329.1,516.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240,289h270.8c9.5,0,17.2-7.7,17.2-17.2v-62.3c0-9.5-7.7-17.2-17.2-17.2H240c-9.5,0-17.2,7.7-17.2,17.2v62.3 C222.7,281.3,230.5,289,240,289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M740.5,417.2H573.8c-9.5,0-17.2,7.7-17.2,17.1l-1.5,297.3c0,1.4-1.2,2.6-2.6,2.6H344.3 c-9.5,0-17.2,7.7-17.2,17.2v62.3c0,9.5,7.7,17.2,17.2,17.2h291.9c9.5,0,17.2-7.7,17.2-17.2V516.6c0-1.5,1.2-2.6,2.6-2.6h84.4 c9.5,0,17.2-7.7,17.2-17.2v-62.3C757.7,424.9,750,417.2,740.5,417.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "dot",
    opacity: 0,
    transform: "translate(10,0)",
    fill: "#00844E"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M733.1,184.8h-60.9c-13.6,0-24.7,11.1-24.7,24.7v62.3c0,13.6,11.1,24.7,24.7,24.7h60.9 c13.6,0,24.7-11.1,24.7-24.7v-62.3C757.7,195.9,746.7,184.8,733.1,184.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "car",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.18) translate(-500,-500) rotate(90 500 500)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B6B6B7",
    d: "M650.9,781.9c-0.7,29.8-1.7,50.1-3.3,55c-3,9.5-12.1,19-28.1,27c-19.9,10.1-50.2,17.9-92.2,20.8 c-8.6,0.6-17.7,1-27.4,1.1c-2.6,0-5.2-0.1-7.8-0.2c-6.8-0.2-13.3-0.5-19.6-0.9c-42-2.9-72.3-10.7-92.2-20.8 c-15.9-8.1-25.1-17.5-28.1-27c-1.6-5-2.6-25.2-3.3-55c-2.5-109.8,0.1-349.8,0.4-436.4c0-5.8,0-10.9,0-15.2V330 c0-70.4-4.2-116.8,12.6-154.8l0,0c3.7-8.4,8.5-16.4,14.6-24.2c9.9-12.6,24.5-21.3,42-27c5-1.6,10.2-3,15.5-4.2 c4.1-0.9,8.3-1.7,12.5-2.3c14.3-2.2,29.7-3.1,45.4-3.2c2.6,0,5.2,0,7.8,0c18.3-0.3,36.4,0.6,53.2,3.2c4.3,0.6,8.5,1.4,12.5,2.3 c5.4,1.2,10.6,2.6,15.5,4.2c17.4,5.7,32,14.3,42,27c6.1,7.8,10.9,15.8,14.6,24.2l0,0c16.8,37.9,12.6,84.4,12.6,154.8v0.3 c0,4.3,0,9.4,0,15.2C650.8,432,653.4,672,650.9,781.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAF9DE",
    d: "M418.8,123.9c-23.8,25.8-43.5,73.4-49,75.2c-4,1.3-7.2-11.4-7.6-24l0,0c3.7-8.4,8.5-16.4,14.6-24.2 C386.8,138.3,401.4,129.6,418.8,123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636464",
    d: "M363.5,336.2c0,0,25.9,78.3,28.7,97.2c2.8,18.9,3.5,158.7-1.4,205.6c-4.9,46.9-17.5,79.7-19.6,86 s-11.9-49.6-11.9-86C359.3,602.7,363.5,336.2,363.5,336.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F3F3F3",
    points: "399.9,515.2 355.1,496.4 355.8,538.3 399.2,550.9  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    d: "M352,331c-10.1-4.9-38.8,10.8-39.9,21.3c-1,10.5,4.2,21.3,4.2,21.3l37.1-31.5L352,331z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B93434",
    d: "M380.4,863.9c-15.9-8.1-25.1-17.5-28.1-27c-1.6-5-2.6-25.2-3.3-55c6.2,6.1,14.5,14.8,15.9,18 C366.9,804.3,362.3,838.8,380.4,863.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAF9DE",
    d: "M637.8,175.1L637.8,175.1c-0.4,12.7-3.6,25.4-7.6,24c-5.5-1.8-25.1-49.4-49-75.2c17.4,5.7,32,14.3,42,27 C629.3,158.7,634.1,166.7,637.8,175.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636464",
    d: "M612.7,274.7c-9.9-11.5-37.3-19.3-68.5-23.4c-14.4-2-29.6-3.2-44.2-3.6c-14.6,0.4-29.8,1.6-44.2,3.6 c-31.1,4.2-58.6,11.9-68.5,23.4c-12.6,14.7,9.8,118.2,16.8,118.9c6.5,0.7,34.8-10.2,90.6-11.2c1.8,0,3.6,0,5.3,0 c1.8,0,3.6,0,5.3,0c55.8,1,84.1,11.8,90.6,11.2C602.9,392.9,625.3,289.4,612.7,274.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636464",
    d: "M636.5,336.2c0,0-25.9,78.3-28.7,97.2c-2.8,18.9-3.5,158.7,1.4,205.6c4.9,46.9,17.5,79.7,19.6,86 s11.9-49.6,11.9-86C640.7,602.7,636.5,336.2,636.5,336.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F2F2F2",
    points: "600.1,515.2 644.9,496.4 644.2,538.3 600.8,550.9  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    d: "M683.7,373.6l-33.2-28.2l-3.9-3.3L648,331c0.7-0.3,1.6-0.6,2.4-0.8c11.6-1.9,36.5,12.3,37.4,22.1 C688.9,362.8,683.7,373.6,683.7,373.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B93434",
    d: "M650.9,781.9c-0.7,29.8-1.7,50.1-3.3,55c-3,9.5-12.1,19-28.1,27c18.1-25.1,13.6-59.6,15.5-64.1 C636.4,796.6,644.7,788,650.9,781.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636464",
    d: "M609.9,798.1l-16.6-77.7c-1.2-5.7-6.9-9.2-12.5-7.7c-14.4,3.9-43.2,10.2-80.9,11c-37.6-0.8-66.5-7.1-80.9-11 c-5.6-1.5-11.2,2-12.5,7.7l-16.6,77.7c-0.9,4.2,0.9,8.4,4.5,10.7c1.3,0.8,46.2,25,109.1,25s100.5-24.3,101.7-25 C609,806.5,610.8,802.2,609.9,798.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E7",
    d: "M591.6,423.3l-1.9,257.4c-0.1,8.9-6.3,16.6-14.9,18.5c-4.1,0.9-8.8,1.9-14,2.9c-17,3.2-39.4,6.5-60.8,6.8 c-17.8-0.2-36.3-2.6-51.8-5.2c-3.1-0.5-6.1-1-9-1.6c-5.2-1-9.9-2-14-2.9c-8.7-1.9-14.9-9.6-14.9-18.5l-1.9-257.4 c0-7.8,4.5-14.8,11.7-17.7c5.9-2.5,13.7-5.4,22.7-7.8c0.9-0.3,1.8-0.5,2.7-0.7c5.6-1.4,11.6-2.6,17.9-3.4c0.1,0,0.2,0,0.3,0 c2.1-0.3,4.1-0.5,6.2-0.7c9.1-0.8,19.5-1,29.8-0.8h0.8c10.3-0.1,20.7,0.1,29.8,0.8c2.1,0.2,4.2,0.4,6.2,0.7c0.1,0,0.2,0,0.3,0 c6.3,0.8,12.3,2,17.9,3.4c10.2,2.6,19,5.8,25.4,8.6C587.1,408.5,591.7,415.5,591.6,423.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M610.6,854.4c-1.4,4.9-55.1,21.8-109.2,21.9c-42.1,0-84.4-9.9-102.7-16.7c-5.7-2.1-9-3.9-9.3-5.1 C384.5,837,388,816,388,816s4.1,2.9,12,6.7c17,8.4,51.5,21.7,100.1,21.7c71,0,111.9-28.4,111.9-28.4S615.5,836.9,610.6,854.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F7",
    d: "M616.2,258.6c-36.4-17.7-79.2-23.6-115.7-24.5h-0.9c-30.3,0.8-64.7,5-96.4,16.4c-6.6,2.3-13,5-19.3,8.1 c-7.3-27.2,1.7-81.1,22.3-106.4c3.2-4,6.8-7.3,10.5-9.6c3.4-2.2,8-4.1,13.4-5.7c17.4-5.4,43.6-8.1,69.8-8.6h0.3 c34.4,0.6,68.6,5.1,83.2,14.3c3.8,2.4,7.3,5.7,10.5,9.6C614.5,177.6,623.4,231.4,616.2,258.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M448.2,703.7c-3.1-0.5-6.1-1-9-1.6c-5.2-1-9.9-2-14-2.9c-8.7-1.9-14.9-9.6-14.9-18.5l-1.9-257.4 c0-7.8,4.5-14.8,11.7-17.7c5.9-2.5,13.7-5.4,22.7-7.8C409.8,450.1,406.2,638,448.2,703.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M398.7,859.5c-5.7-2.1-9-3.9-9.3-5.1c-4.9-17.5-1.4-38.5-1.4-38.5s4.1,2.9,12,6.7 C391.7,831.9,389.7,847.3,398.7,859.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M403.2,250.5c-6.6,2.3-13,5-19.3,8.1c-7.3-27.2,1.7-81.1,22.3-106.4c3.2-4,6.8-7.3,10.5-9.6 c3.4-2.2,8-4.1,13.4-5.7C397.3,165.1,382.9,222.5,403.2,250.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M317,366.3c0,0-3.8-12.2-1-16.1c2.8-3.8,22-18.2,32.2-17.5c-8.4,2.8-27.6,17.8-29,20.6 C317.7,356.2,317,366.3,317,366.3z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#F7F8F9",
    d: "M684.2,366.3c0,0,3.8-12.2,1-16.1c-2.8-3.8-22-18.2-32.2-17.5c8.4,2.8,27.6,17.8,29,20.6 C683.5,356.2,684.2,366.3,684.2,366.3z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200,1030)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#bebebe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.31,124.85V64.79h7.6v53.56h26.28v6.5Z",
    transform: "translate(-97.31 -63.69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.38,126a24.26,24.26,0,0,1-10.4-2.2,23.07,23.07,0,0,1-8.1-6.27,29.37,29.37,0,0,1-5.27-9.89,42.36,42.36,0,0,1-1.87-13,41.48,41.48,0,0,1,1.87-13,28.37,28.37,0,0,1,5.27-9.71,22.81,22.81,0,0,1,8.1-6.09,25.3,25.3,0,0,1,10.4-2.1,24.68,24.68,0,0,1,10.39,2.15A23.61,23.61,0,0,1,225.92,72a28,28,0,0,1,5.31,9.71,41.15,41.15,0,0,1,1.88,12.86,42.35,42.35,0,0,1-1.88,13,28.91,28.91,0,0,1-5.31,9.89,23.52,23.52,0,0,1-8.15,6.27A24.25,24.25,0,0,1,207.38,126Zm0-6.68a15.1,15.1,0,0,0,7.28-1.75,16.38,16.38,0,0,0,5.58-5,24.81,24.81,0,0,0,3.62-7.79,37.67,37.67,0,0,0,1.28-10.21,36.82,36.82,0,0,0-1.28-10.07,23.23,23.23,0,0,0-3.62-7.6,16.59,16.59,0,0,0-5.58-4.81,16.52,16.52,0,0,0-14.56,0,16.53,16.53,0,0,0-5.59,4.81,23.23,23.23,0,0,0-3.62,7.6,36.82,36.82,0,0,0-1.28,10.07,37.67,37.67,0,0,0,1.28,10.21,24.81,24.81,0,0,0,3.62,7.79,16.32,16.32,0,0,0,5.59,5A15,15,0,0,0,207.38,119.27Z",
    transform: "translate(-97.31 -63.69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.92,124.85l20.32-60.06h8.61l20.33,60.06H324l-5.68-18.31H296.47l-5.77,18.31Zm18.31-33.6-2.84,9.15h18l-2.84-9.15q-1.65-5-3.11-10T307.55,71h-.37q-1.37,5.22-2.84,10.21T301.23,91.25Z",
    transform: "translate(-97.31 -63.69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.48,124.85V64.79h15q13.92,0,21.15,7.69t7.24,22.06a41.33,41.33,0,0,1-1.83,12.78,25.41,25.41,0,0,1-5.41,9.52,23.27,23.27,0,0,1-8.79,6,32.33,32.33,0,0,1-12,2.06Zm7.6-6.23h6.86q10.53,0,15.8-6.31T422,94.54q0-11.45-5.26-17.49t-15.8-6h-6.86Z",
    transform: "translate(-97.31 -63.69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.57,124.85V64.79h7.6v60.06Z",
    transform: "translate(-97.31 -63.69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.44,124.85V64.79h7.87L588,102.51l6.5,12.45h.37q-.27-4.58-.6-9.47T594,95.83v-31h7.24v60.06h-7.88L571.53,87,565,74.67h-.37c.25,3.06.47,6.15.69,9.3s.32,6.3.32,9.47v31.41Z",
    transform: "translate(-97.31 -63.69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.08,126a27.78,27.78,0,0,1-10.94-2.11,23.62,23.62,0,0,1-8.56-6.09A28.5,28.5,0,0,1,662,108a40.11,40.11,0,0,1-2-13.14,38.55,38.55,0,0,1,2.06-13,28.61,28.61,0,0,1,5.72-9.8,24.55,24.55,0,0,1,8.75-6.18,27.89,27.89,0,0,1,11-2.15A23.57,23.57,0,0,1,698,66a21.65,21.65,0,0,1,3.85,2.38,27.49,27.49,0,0,1,3,2.7l-4.21,5a21.76,21.76,0,0,0-5.32-4,15.69,15.69,0,0,0-7.6-1.65,19.39,19.39,0,0,0-8.24,1.69,17.23,17.23,0,0,0-6.22,4.86,23,23,0,0,0-4,7.64,33.51,33.51,0,0,0-1.42,10.07,36.58,36.58,0,0,0,1.33,10.22,22.78,22.78,0,0,0,3.85,7.73,16.79,16.79,0,0,0,6.23,4.94,19.77,19.77,0,0,0,8.56,1.75,19.22,19.22,0,0,0,6.09-1,13.3,13.3,0,0,0,4.71-2.62V100H685.89V93.72h19.69V119a22.51,22.51,0,0,1-7.69,5A28.15,28.15,0,0,1,687.08,126Z",
    transform: "translate(-97.31 -63.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dot-1",
    opacity: 0,
    d: "M770.13,126a6.58,6.58,0,0,1-4.9-2,7.66,7.66,0,0,1,0-10.26,6.59,6.59,0,0,1,4.9-2,6.44,6.44,0,0,1,4.85,2,7.78,7.78,0,0,1,0,10.26A6.43,6.43,0,0,1,770.13,126Z",
    transform: "translate(-97.31 -63.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dot-2",
    opacity: 0,
    d: "M841.1,126a6.57,6.57,0,0,1-4.9-2,7.66,7.66,0,0,1,0-10.26,6.58,6.58,0,0,1,4.9-2,6.44,6.44,0,0,1,4.85,2,7.81,7.81,0,0,1,0,10.26A6.43,6.43,0,0,1,841.1,126Z",
    transform: "translate(-97.31 -63.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dot-3",
    opacity: 0,
    d: "M912.06,126a6.57,6.57,0,0,1-4.9-2,7.66,7.66,0,0,1,0-10.26,6.58,6.58,0,0,1,4.9-2,6.44,6.44,0,0,1,4.85,2,7.81,7.81,0,0,1,0,10.26A6.43,6.43,0,0,1,912.06,126Z",
    transform: "translate(-97.31 -63.69)"
  }), /*#__PURE__*/React.createElement("animate", {
    xlinkHref: "#dot-1",
    attributeName: "opacity",
    dur: "1s",
    begin: "0s;dot-anim3.end + 0.2s",
    calcMode: "spline",
    keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
    values: "0;1;0",
    keyTimes: "0;0.3;1",
    id: "dot-anim1"
  }), /*#__PURE__*/React.createElement("animate", {
    xlinkHref: "#dot-2",
    attributeName: "opacity",
    dur: "1s",
    begin: "dot-anim1.begin + 0.2s",
    calcMode: "spline",
    keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
    values: "0;1;0",
    keyTimes: "0;0.3;1",
    id: "dot-anim2"
  }), /*#__PURE__*/React.createElement("animate", {
    xlinkHref: "#dot-3",
    attributeName: "opacity",
    dur: "1s",
    begin: "dot-anim2.begin + 0.2s",
    calcMode: "spline",
    keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
    values: "0;1;0",
    keyTimes: "0;0.3;1",
    id: "dot-anim3"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "fullPath",
    fill: "none",
    d: "M75 675 L370 675 Q500,675 500,545 L500 500 L500 480 Q500,360 630,360 L670 360 L900 360"
  }), /*#__PURE__*/React.createElement("animateMotion", {
    xlinkHref: "#car",
    dur: "3.5s",
    begin: 0,
    rotate: "auto",
    id: "motion-anim",
    calcMode: "linear",
    keyPoints: "0;0.53;0.53;0.79;0.79;1",
    keyTimes: "0;0.35;0.5;0.75;0.83;1",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#fullPath"
  })), /*#__PURE__*/React.createElement("animate", {
    xlinkHref: "#car",
    attributeName: "opacity",
    values: "0;1;1;1;1;1;1;1;1;1;1;1;1;0",
    dur: "3.5s",
    begin: "motion-anim.begin + 0ms",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    xlinkHref: "#dot",
    attributeName: "opacity",
    values: "0;0;0;0;0;0;0;0;0;0;0;1;1;0",
    dur: "3.5s",
    begin: "motion-anim.begin + 0ms",
    repeatCount: "indefinite"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoaderVehicle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/loaderVehicle.4b9d1751.svg";
export { ForwardRef as ReactComponent };